import { LuClock } from "react-icons/lu";

function RefundConfirmationRequestProgress({ data }) {
  const steps = [
    "Request Received",
    "Refund Review",
    "Quote Ready",
    "Awaiting Approval",
    "Refund Progress",
    "Refund, to be reimbursed",
    "Refund Completed",
  ];

  let activeStep = 2;
  if (data?.status) {
    switch (data?.status) {
      case "Success":
        activeStep = 8;
        break;
      case "PendingRefund":
        activeStep = 6;
        break;
      case "Approved":
        if (data?.confirmed) {
          activeStep = 5;
          break;
        }
        if (data?.approvedByAdmin) {
          activeStep = 4;
          break;
        }
        if (data?.isQuoted || data?.priceReceived) {
          activeStep = 3;
          break;
        }
      default:
        break;
    }
  }

  return (
    <div className="w-full bg-white px-6 py-4 border border-gray-200 rounded-xl shadow-sm hidden lg:flex flex-col justify-between items-center mt-4 gap-3">
      {/* <div className="w-full flex mb-2">
        <span className="">Request Progress</span>
      </div> */}
      <div className="w-full flex justify-between  items-center">
        {steps.map((label, index) => {
          const stepNum = index + 1;
          const isActive = stepNum === activeStep;
          const isCompleted = stepNum < activeStep;

          return (
            <div
              key={label}
              className="flex-1 flex flex-col items-center relative"
            >
              {/* Step Circle */}
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center z-10 ${
                  isCompleted
                    ? "bg-primary1 text-white"
                    : isActive
                    ? "bg-yellow-400 text-white"
                    : "bg-gray-200 text-gray-500"
                }`}
              >
                {isCompleted ? (
                  <span className="text-lg font-semibold">✓</span>
                ) : isActive ? (
                  <LuClock className="text-lg text-white" />
                ) : (
                  <span className="text-base font-semibold">{stepNum}</span>
                )}
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div
                  className={`absolute left-1/2 top-5 h-[2px] w-full -translate-y-1/2 ${
                    isCompleted ? "bg-primary1" : "bg-gray-200"
                  }`}
                ></div>
              )}

              {/* Label */}
              <div
                className={
                  "whitespace-nowrap text-xs mt-1 " +
                  (isActive ? "text-black" : "text-gray-400")
                }
              >
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RefundConfirmationRequestProgress;
